export default __webpack_public_path__ + "static/media/thumbnail2.fbfa0d50.jpg";